import gql from 'graphql-tag';

const ALL_MEDIA_PENDING = gql`
query mediaTable(
  $offset: Int
  $limit: Int
  $sort: [MediaTableSortInput!]
  $filter: [MediaTableFilterInput]
) {
  mediaTable(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
    totalCount
    items {
      id
      bid
      name
      status
      category
      size
      owner
      acceptanceStatus
      createdAt
      acceptanceDescription
      url
    }
  }
}
`;

export default ALL_MEDIA_PENDING;